import React from 'react'
import { fetchChatEnabled } from '../services/chatService'

export function useChatEnabled() {
  const [enabled, setEnabled] = React.useState<boolean | null>(null)

  React.useEffect(() => {
    let mounted = true
    ;(async () => {
      try {
        const ok = await fetchChatEnabled()
        if (!mounted) return
        setEnabled(ok)
      } catch {
        if (!mounted) return
        setEnabled(false)
      }
    })()
    return () => {
      mounted = false
    }
  }, [])

  return enabled
}
